import { Table } from '@material-ui/core';
import { Form } from '@unform/web';
import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #101d40;

      span {
        font-weight: 600;
      }
    }
  }

  .create_user {
    display: flex;
    justify-content: flex-end;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 13px 18px;
      border-radius: 5px;
      font-family: Sora, sans-serif;
      font-weight: 600;
      font-size: 15px;
      border: none;
      cursor: pointer;
      background-color: #329bfc;
      color: #ffffff;
      width: 100%;
      max-width: 300px;
      text-decoration: none;

      &:hover:not(:disabled) {
        background-color: ${darken(0.1, '#329bfc')};
      }

      &:disabled {
        background-color: rgba(0, 0, 0, 0.12);
      }
    }
  }

  header {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .previous_page {
      border: none;
      background: transparent;
      display: flex;
      align-items: center;
      color: #9e9e9e;
      gap: 4px;
      font-size: 16px;
      font-weight: 600;
    }

    .previous_page:hover {
      color: #329bfc;
    }

    h1 {
      font-size: 24px;
      font-weight: 600;
      color: #263238;
    }

    p {
      color: #757575;
      font-size: 16px;
      font-weight: 300;
    }
  }
`;

export const CustomForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Sora', sans-serif;
    color: #101d40;
  }

  .multi {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;

    & > div {
      min-width: 250px;
      flex: 2;
    }

    & > div:last-child {
      flex: 1;
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    width: 100%;

    & > button {
      max-width: 250px;
      min-width: 200px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;
    svg {
      color: #f64444;
      font-size: 50px;
    }
  }
  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }
  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  p {
    text-align: start;
    color: #000;
    span {
      color: #acb3be;
    }
  }
  .form {
    display: flex;
    width: 100%;
  }
`;

export const CustomTable = styled(Table)`
  border-collapse: initial;
  font-family: Sora, sans-serif;
`;

export const TableCell = styled.tr`
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #101d40;

  &:last-child {
    margin-left: -25px;
  }
`;

export const TableHeader = styled.thead`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: 150px 150px minmax(250px, 1fr) 50px 160px;
  padding: 16px;
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;

  ${TableCell} {
    &:nth-child(1) {
      width: 150px;
    }

    &:nth-child(2) {
      width: 150px;
      text-align: left;
    }

    &:nth-child(3) {
      width: 300px;
    }

    &:nth-child(4) {
      width: 50px;
    }

    &:nth-child(5) {
      width: 160px;
    }
  }
`;

export const TableBody = styled.tbody`
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #101d40;
`;

export const ContainerList = styled.ul`
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #444;
    gap: 8px;

    & + li {
      margin-top: 15px;
    }

    .info {
      display: flex;
      flex-direction: column;
      flex: 1;

      div {
        display: flex;
        justify-content: space-between;
      }

      .relation__product {
        width: fit-content;
      }
    }

    .relation__product {
      background: transparent;
      border: none;
      color: #329bfc;
      border: 1px solid transparent;
      padding: 2px;
      border-radius: 4px;

      &:hover {
        border-color: #329bfc;
      }
    }
  }

  .icons {
    display: flex;
  }
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: 150px 150px minmax(250px, 1fr) 50px 160px;
  border-top: 1px solid #e6effb;
  padding: 16px;
  align-items: center;
  background-color: #ffffff;
`;

export const TableCellRow = styled.div`
  text-align: center;

  p {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #101d40;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  svg:hover {
    color: #329bfc;
    cursor: pointer;
    animation: 3ms;
  }

  &:nth-child(2) {
    width: 150px;
  }

  &:nth-child(3) {
    width: 300px;
  }

  &:nth-child(4) {
    width: 50px;
  }
  &:nth-child(5) {
    width: 160px;
  }
`;
